<template>
  <div class="mb-3 p-3 rounded-6 bg-history border-form">
    <div class="d-flex align-items-center justify-content-between border-b-form pb-2">
      <p class="body-3-3-2 mb-0 pr-3 ls-1-25">{{ data.invoice }}</p>
      <p class="body-3-3-2 mb-0 restaurant-status-transaction" :class="`restaurant-status-${data.status}`">{{ status }}</p>
    </div>
    <div class="d-flex align-items-center py-3">
      <div class="flex-shrink-0">
        <img v-if="isDelivery" src="../../assets/img/icon/fast-delivery.png" width="30">
        <img v-else src="../../assets/img/icon/cutlery.png" width="30">
      </div>
      <div class="w-100">
        <div class="d-flex pl-3 justify-content-between w-100">
          <div class="w-100 pr-3 flex-shrink-1">
            <p class="mb-0 body-2-4 text-truncate" style="width: 190px;">{{ products }}</p>
            <p class="body-3-1 mb-0">{{ $formatDateTime(data.created_at) }}</p>
          </div>
          <div class="text-right">
            <p class="mb-0 body-2-4">{{ $formatCurrency(data.total_payment) }}</p>
            <p class="body-3-3-2 mb-0">{{ isDelivery ? 'Delivery' : 'Dine In' }}</p>
          </div>
        </div>
      </div>
    </div>
    <button class="g-btn g-btn-sm g-btn-primary-outline w-100 rounded-6" @click="goToDetail()">View Detail</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';


  export default {
    props:{
      data:{
				type: Object,
				default: () => {}
			},
    },
    computed:{
      ...mapGetters(['getMerchant']),
      isDelivery(){
        return this.$isNotEmpty(this.data.order_type === 'DELIVERY');
      },  
      status(){
        if(!this.data) return '';
        return this.$parsingRestaurantStatusText(this.data.status);
      },
      products(){
        if(!this.data) return '';
        const { tx_detail_list } = this.data;
        let text = `${tx_detail_list[0].qty} ${tx_detail_list[0].product_name}`
        if(tx_detail_list.length > 1) text += " and more";
        return text;
      }
    },
    methods:{
      goToDetail(){
      	this.$router.push(`/${this.getMerchant.code}/r/order-history/${this.data.id}`)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/restaurant-v2/OrderHistoryItem.vue